<template>
  <div>
    <div class="text-center titles font-weight-bold">
      აირჩიე ვიზიტის თარიღი
    </div>
    <div class="text-center small text-danger" v-if="$v.date.$error">გთხოვთ აირჩიოთ სასურველი რიცხვი</div>
    <div class="d-flex  justify-content-center mt-3">
      <Datepicker :format="'yyyy-MM-dd'"
                  :language="ge"
                  name="datepicker"
                  id="input-id"
                  :full-month-name="true"
                  input-class=" col-12 calendar calendari"
                  :inline="true"
                  v-model.trim="date"
                  v-bind:class="{ 'has-error': $v.date.$error }"
                  :disabledDates="disabledDates"
      ></Datepicker>
    </div>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import Datepicker from 'vuejs-datepicker'
import {ge} from 'vuejs-datepicker/dist/locale'
let that;
export default {
  name: "step-5",
  components: {
    Datepicker
  },
  props:['activeDates'],
  data() {
    return {
      date: '',
      ge: ge,
      disabledDates: {
        customPredictor: function (date) {
          let cd=new Date(date);  let d= new Date(cd.getFullYear(), cd.getMonth(), cd.getDate(), 0,0,0)
          if(!that.some((element) => new Date(element).valueOf() === d.valueOf()))
          return true
        }
      }
    }
  },
  updated() {
    let element = document.getElementsByClassName("today");
    element[0].classList.remove("today");
  },
  mounted() {
    that=this.activeDates
  },
  validations: {date: {required}}
}
</script>

<style scoped>


</style>